<template>
    <v-row
        no-gutters
        class="pl-6 pr-8 pt-8"
    >
        <v-col cols="12">
            <v-row no-gutters class="mb-8">
                <v-col cols="12">
                    <AppStoreListHeader
                        :item-label="$t('Contract templates')"
                        :add-label="$t('Add')"
                        show-button
                        @add-item="editTemplate(0)"
                    />
                    <v-row
                        v-if="contractTemplates.length > 0"
                        no-gutters
                    >
                        <v-col cols="12">
                            <data-table
                                :headers="headers"
                                :items="contractTemplates"
                                :loading="loader.isLoading"
                                row-clickable
                                @click:row="editTemplate($event.id)"
                            />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import { $t } from "@/i18n";
import { computed, reactive } from "@vue/composition-api";
import DialogModule from "@/store/modules/dialog";
import ContractModule from "@/store/modules/contract";
import AppStoreListHeader from "../../../components/AppStore/AppStoreListHeader";
import AddButton from "@/components/Buttons/AddButton";
import DownloadButton from "@/components/Buttons/DownloadButton";
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import { Router } from "../../../composables/Router";
import Loader from "../../../utility/loader";
import AppModule from "../../../store/modules/app";
import errorDialog from "@/views/ErrorDialog/errorDialog"

export default {
    name: "BillingDialogContractTemplatesTab",
    components:{
        AppStoreListHeader,
        AddButton,
        DownloadButton
    },
    setup() {
        const router = Router();
        const { closeDialog } = DialogModule();
        const { appStoreDialogGetters } = appStoreDialog()
        const { fetchContractTemplates, contractTemplates } = ContractModule();
        const loader = reactive(new Loader())

        const selectedAccount = computed(() => {
            return appStoreDialogGetters.getSelectedCompany()
        })

        const accountId = computed(() => {
            return selectedAccount.value.id
        })

        const editTemplate = (id) => {
            router.push({ name: "new_contract_template", params: { accountId: accountId.value, contractId: id }});
            closeDialog();
        }

        const headers = [
            { value: "template_name", text: $t("Name") },
            { value: "edit", sortable: false }
        ]

        loader.withLoader(async () => {
            try {
                await fetchContractTemplates({ account_id: selectedAccount.value.id })
            } catch (e) {
                errorDialog.showError(e)
            }

        })

        return {
            contractTemplates,
            editTemplate,
            headers,
            loader
        };
    }
}
</script>

<style scoped>

</style>